import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { User } from 'projects/core/src/lib/login/data/user';
import { CabinetType } from 'projects/app-misc/src/app/modules/reports/data/cabinet-type';

@JsonObject('model.CabinetComplexityVariation')
export class CabinetComplexityVariation extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'back')
  back?: string;

  @JsonProperty(String, 'cabinetName')
  cabinetName?: string;

  @JsonProperty(Number, 'cabinetStyle')
  cabinetStyle?: number;

    @JsonProperty(CabinetType, 'cabinetType')
  cabinetType?: CabinetType;

  @JsonProperty(Number, 'complexityMultiplier')
  complexityMultiplier?: number;

  @JsonProperty(Number, 'complexityStyle')
  complexityStyle?: number;

  @JsonProperty(Number, 'complexityType')
  complexityType?: number;

  @JsonProperty(Number, 'depth')
  depth?: number;

  @JsonProperty(Number, 'height')
  height?: number;

  @JsonProperty(Number, 'width')
  width?: number;

  @JsonProperty(String, 'leftEnd')
  leftEnd?: string;

  @JsonProperty(Number, 'overallComplexity')
  overallComplexity?: number;

  @JsonProperty(String, 'rightEnd')
  rightEnd?: string;

}
